import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { GET_USER_LIST, GET_USER_LIST_SUCCESS, GET_USER_LIST_ERROR } from './../../actionType';
import { Constant } from '../../../../Containers/Helpers/constant';
import cogoToast from 'cogo-toast';
import apiCall from '../../apiCall';
import { baseUrl, customHeaders, indianProjectsBaseURL } from '../../../../Containers/Config';

function* getUsersList({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/admin/user-info`,
      method: 'POST',
      headers: { Authorization: Constant?.CLIENT_TOKEN, ...customHeaders },
      data: payload?.data,
      params: {
        ...payload?.urlParam,
      },
    });

    if (response.status === 200) {
      yield put({ type: GET_USER_LIST_SUCCESS, payload: response?.data });
    } else {
      // cogoToast.error(response?.response?.data?.message)
      yield put({ type: GET_USER_LIST_ERROR, payload: response?.data?.message });
    }
  } catch (error) {
    yield put({ type: GET_USER_LIST_ERROR, payload: error });
  }
}

export function* watchGetUsersList() {
  yield takeEvery(GET_USER_LIST, getUsersList);
}

function* getUsersListSaga() {
  yield all([fork(watchGetUsersList)]);
}

export default getUsersListSaga;
